export default __webpack_public_path__ + "static/Agile-BookItalic-1fc8578cd4335a5f0c8055553e95a5c5.ttf";